import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withAppContext } from '../../../contexts/app';
import { withClinicalData } from '../../../contexts/clinicalData';

class Navigator extends Component {
  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    const conditions = props.clinicalData.inference.predictions.map(p => p.condition);
    const currentConditionIndex = conditions.findIndex(c => c.healthPage === props.currentConditionId);

    const previousCondition = currentConditionIndex > 0 ? conditions[currentConditionIndex - 1] : null;
    const nextCondition = currentConditionIndex < (conditions.length - 1) ? conditions[currentConditionIndex + 1] : null;

    const conditionLinkBase = `${props.app.healthPages.basePath}${props.app.healthPages.conditionPagesPath}`;

    return {
      numConditions: conditions.length,
      current: {
        num: currentConditionIndex + 1,
        condition: conditions[currentConditionIndex]
      },
      previous: {
        num: currentConditionIndex,
        condition: previousCondition,
        link: previousCondition ? `${conditionLinkBase}/${previousCondition.healthPage}` : null
      },
      next: {
        num: currentConditionIndex + 2,
        condition: nextCondition,
        link: nextCondition ? `${conditionLinkBase}/${nextCondition.healthPage}` : null
      }
    };
  }

  render() {
    const isSingleLink = !(this.state.previous.condition && this.state.next.condition);

    return (
      <div className="condition-navigator">
        <div className="container">

          { this.state.previous.condition &&
            <Link to={this.state.previous.link} className={`condition-navigator__left${isSingleLink ? ' centered' : ''}`}>
              <React.Fragment>
                <span className="condition-navigator__link">
                  <span className="condition-navigator__button"><i className="icon icon--back"/></span>
                  <span>Previous Condition { this.state.previous.num }/{ this.state.numConditions }</span>
                </span>
                <span className="condition-navigator__label">{ this.state.previous.condition.commonName }</span>
              </React.Fragment>
            </Link>
          }

          { this.state.next.condition &&
            <Link to={this.state.next.link} className={`condition-navigator__right${isSingleLink ? ' centered' : ''}`}>
              <React.Fragment>
                <span className="condition-navigator__link">
                  <span>Next Condition { this.state.next.num }/{ this.state.numConditions }</span>
                  <span className="condition-navigator__button"><i className="icon icon--forward"/></span>
                </span>
                <span className="condition-navigator__label">{ this.state.next.condition.commonName }</span>
              </React.Fragment>
            </Link>
          }

        </div>
      </div>
    );
  }
}

Navigator.defaultProps = {};

Navigator.propTypes = {
  app: PropTypes.object.isRequired,
  clinicalData: PropTypes.object.isRequired,
  currentConditionId: PropTypes.string
};

export default withAppContext(withClinicalData(Navigator));
